<form class="row gy-2 gx-3 align-items-center">
  <div class="col-sm-auto" *ngIf="showAddBtn">
    <button type="button" class="btn btn-success w-md"
            (click)="onAddButtonClick()">
      <i class="mdi mdi-plus-circle me-2"></i>
      <span *ngIf="addBtnText!='Add'">{{ addBtnText }}</span>
      <span *ngIf="addBtnText=='Add'" i18n="@@label.Add">Add</span>
    </button>
  </div>

  <div class="col-sm-auto" *ngFor="let ff of extraFields">
    <label class="visually-hidden" for="fromDate">{{ ff.label }}</label>

    <input *ngIf="ff.type === 'text'"
           type="text" class="form-control" id="title-input"
           placeholder="{{ff.placeholder}}"
           [(ngModel)]="filterData.extra[ff.name]"
           [ngModelOptions]="{standalone: true}">

    <!--    <select *ngIf="ff.type === 'dropdown'"-->
    <!--            id="formrow-inputState" class="form-select select2"-->
    <!--            [name]="ff.name"-->
    <!--            [(ngModel)]="filterData.extra[ff.name]">-->
    <!--      <option value="{{ ff.value }}">{{ ff.placeholder }}</option>-->
    <!--      <option *ngFor="let op of ff.options" value="{{op.value}}">-->
    <!--        {{ op.label }}-->
    <!--      </option>-->
    <!--    </select>-->

    <div class="btn-group" *ngIf="ff.type === 'dropdown'">
      <button type="button" class="btn btn-outline-secondary dropdown-toggle"
              data-bs-toggle="dropdown" aria-expanded="false">
        {{ getSelectedLabel(ff) }}
        <i class="mdi mdi-chevron-down"></i>
      </button>
      <div class="dropdown-menu">
        <a class="dropdown-item" *ngFor="let op of ff.options"
           (click)="onFilterOptionSelected(ff.name, op.value)">
          {{ op.label }}
        </a>
      </div>
    </div>

    <!--    DD-MM-YYYY h:mm:ss a   -->
    <div *ngIf="ff.type === 'date'" class="input-group">
      <input class="form-control" bsDatepicker
             id="{{ff.name}}"
             [bsConfig]="{ dateInputFormat: 'DD-MM-YYYY' }"
             [name]="ff.name"
             [(ngModel)]="filterData.extra[ff.name]"
             [ngModelOptions]="{standalone: true}">
    </div>
  </div>

<!--  <div class="col-sm-2" *ngIf="isAdmin">-->
<!--    <app-user-filter-->
<!--      [username]="filterData.username"-->
<!--      (selected)="filterData.username=$event"/>-->
<!--  </div>-->
  <div class="col-sm-auto">
    <label class="visually-hidden" for="fromDate">From</label>
    <div class="input-group">
      <input class="form-control" bsDatepicker id="fromDate"
             [bsConfig]="{ dateInputFormat: 'DD-MM-YYYY' }"
             [(ngModel)]="filterData.fromDate"
             [ngModelOptions]="{standalone: true}" [maxDate]="filterData.toDate">
    </div>
  </div>

  <div class="col-sm-auto">
    <label class="visually-hidden" for="toDate">To</label>
    <div class="input-group">
      <input class="form-control" bsDatepicker id="toDate"
             [bsConfig]="{ dateInputFormat: 'DD-MM-YYYY' }"
             [(ngModel)]="filterData.toDate"
             [ngModelOptions]="{standalone: true}" [minDate]="filterData.fromDate">
    </div>
  </div>

  <div class="col-sm-auto btn-group">
    <button type="button" class="btn btn-primary" (click)="onFilterClick()">
      <span class="ms-2 me-2" i18n="@@label.Filter">Filter</span>
    </button>
    <button type="button" class="btn btn-primary dropdown-toggle dropdown-toggle-split" data-bs-toggle="dropdown"
            aria-expanded="false">
      <i class="mdi mdi-chevron-down"></i>
    </button>
    <div class="dropdown-menu">
      <a class="dropdown-item" href="javascript: void(0);" (click)="filterForToday()" i18n="@@label.Today">Today</a>
      <a class="dropdown-item" href="javascript: void(0);" (click)="filterForYesterday()" i18n="@@label.Yesterday">Yesterday</a>
      <a class="dropdown-item" href="javascript: void(0);" (click)="filterForLast7Days()" i18n="@@label.Last7Day">Last 7
        days</a>
      <div class="dropdown-divider"></div>
      <a class="dropdown-item" href="javascript: void(0);" (click)="filterForThisMonth()" i18n="@@label.ThisMonth">This
        Month</a>
      <a class="dropdown-item" href="javascript: void(0);" (click)="filterForLastMonth()" i18n="@@label.LastMonth">Last
        Month</a>
      <div class="dropdown-divider"></div>
      <a class="dropdown-item" href="javascript: void(0);" (click)="filterForThisYear()" i18n="@@label.ThisYear">This
        Year</a>
      <a class="dropdown-item" href="javascript: void(0);" (click)="filterForLastYear()" i18n="@@label.LastYear">Last
        Year</a>
      <!--      <div class="dropdown-divider"></div>-->
      <!--      <a class="dropdown-item" href="javascript: void(0);" (click)="clearFilter()">Clear</a>-->
    </div>
  </div>

  <div class="col-sm-auto">
    <button type="button" class="btn btn-outline-primary" (click)="clearFilter()">
      <span class="ms-2 me-2" i18n="@@label.Clear">Clear</span>
    </button>
  </div>

</form>
